import { Component, OnInit, Inject, signal } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { httpsCallable } from 'firebase/functions';
import { functions } from 'src/app/app.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-adjust-password',
  templateUrl: './adjust-password.component.html',
  styleUrls: ['./adjust-password.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class AdjustPasswordComponent implements OnInit {
  userForm: UntypedFormGroup;
  saving = signal(false);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AdjustPasswordComponent>,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      passwordVerification: ['', Validators.required],
    });

    this.userForm.controls.passwordVerification.valueChanges.subscribe((val) => {
      if (val !== this.userForm.controls.password.value) {
        this.userForm.controls.passwordVerification.setErrors({
          customError: true,
        });
      }
    });
  }

  async save() {
    this.saving.set(true);
    try {
      const callable = httpsCallable(functions, 'httpUpdateUser');
      const result = await callable({
        type: 'password',
        email: this.userForm.controls.email.value,
        password: this.userForm.controls.passwordVerification.value,
      });
      console.log('result', result);
      if (result.data === 'succes') {
        this.snackBar.open(
          'Er wordt een e-mail gestuurd naar de gebruiker dat hun wachtwoord aangepast is.',
          'X',
          {
            duration: 5000,
          },
        );
        this.saving.set(false);
        this.dialogRef.close();
      } else if (result.data['error'] === 'auth/user-not-found') {
        this.snackBar.open('Er is geen gebruiker gevonden met het opgegeven e-mailadres.', 'X', {
          duration: 5000,
        });
        this.saving.set(false);
      }
    } catch (e) {
      this.saving.set(false);
      console.error(e);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
